module.exports = {"TXTWCL_FromX_N0":{"id":"TXTWCL_FromX_N0","defaultMessage":"Ab: {0}"},"TXTWCL_ToX_N0":{"id":"TXTWCL_ToX_N0","defaultMessage":"Bis: {0}"}}